import React, {useContext} from 'react';
import * as yup from 'yup';

import { FeatureGatingContext } from '../../contexts';
import { AjaxForm } from '../../forms/index.jsx';
import { FieldGroup } from '../../components';

import './request-product.scss';

const fieldObj = (name, label) => ({ name, label: label || name.replace(/_/g, ' ')});

const fields = [
  'brand',
  'model',
  'reference_number',
  ['manufacturer_link', 'PRODUCT LINK FROM MANUFACTURER'],
  ['reseller_link_1', 'PRODUCT LINK FROM RESELLER (1/2)'],
  ['reseller_link_2', 'PRODUCT LINK FROM RESELLER (2/2)'],
  'dial_color',
  'case_material',
  'case_diameter',
  'case_glass',
  'case_back',
  'water_resistance',
  'movement',
  'additional_info',
  'power_reserve',
  'jewels',
].map(field => Array.isArray(field) ? fieldObj(...field) : fieldObj(field));

const requiredFields = ['brand', 'model', 'reference_number', 'manufacturer_link'];

export function RequestProduct() {
  const { checkFeatureQuota } = useContext(FeatureGatingContext);

  const formProps = {
    method: 'post',
    url: '/api/merchant-request-product',
    fields: fields.map(field => field.name),
    validationSchema: yup.object().shape(fields.reduce((acc, field) => {
      acc[field.name] = yup.string().max(1023, 'Too long');
      if (requiredFields.includes(field.name)) {
        acc[field.name] = acc[field.name].required('Required');
      }
      if (field.name.includes('link')) {
        acc[field.name] = acc[field.name].url('Invalid URL');
      }
      return acc;
    }, {})),
    initialValues: fields.reduce((acc, field) => ({ ...acc, [field.name]: '' }), {}),
    requiredFields: [],
    checkQuota: async () => {
      return checkFeatureQuota(FeatureGatingContext.features.ADD_PRODUCT);
    },
  }

  return (
    <div className="request-product">
      <AjaxForm {...formProps} submitLabel="Send" successTitle="Your request has been sent!">
        {fields.map(field => (
          <div key={field.name} className="row field">
            <div className="col-12 col-sm-6 label">
              <label>{field.label}</label>
            </div>
            <div className="col-12 col-sm-6">
              <FieldGroup name={field.name} type="text" placeholder={field.label} />
            </div>
          </div>
        ))}
      </AjaxForm>
    </div>
  );
}
